import { classes } from 'html-classes';
import Skeleton from 'react-loading-skeleton';

import styles from './Tabs.module.scss';

export const ContentSkeleton = () => {
  return (
    <div className={classes([styles.contentWrapper, styles.skeletonWrapper])}>
      <Skeleton containerClassName={styles.titleSkeleton} />
      <Skeleton containerClassName={styles.paragraphSkeleton} />
    </div>
  );
};
